import { useEffect } from "react";

/* 
  This hook is used to hide elements if the browser does not support the :has selector.
  The :has selector is used to select elements that contain a specific element.
  If the browser does not support the :has selector, the badge and footer will be hidden.

  CSS is Swing should be used to hide the badge and footer if the browser does not support the :has selector.
  However, this doesn't work for iPhone 12s running iOS 14. 
*/

const useHideElementsIfNoHasSupport = () => {
  useEffect(() => {
    // Check if the browser supports the :has selector
    const supportsHas = CSS.supports("selector(:has(a, b))");

    if (!supportsHas) {
      // Apply styles to hide the badge & footer if :has is not supported
      const badges = document.querySelectorAll(".card__wrapper .card .badge");
      badges.forEach((badge) => {
        badge.style.display = "none";
      });

      const footers = document.querySelectorAll(".card__wrapper .card .card__footer");
      footers.forEach((footer) => {
        footer.style.display = "none";
      });
    }
  }, []);
};

export default useHideElementsIfNoHasSupport;
